export const WELCOME_DONE_ROUTE = '/welcome/done';
export const WELCOME_COMPLETION_ROUTE = WELCOME_DONE_ROUTE;

const WELCOME_SKIPPABLE_SETUP_ROUTES = [
  '/welcome/join',
  '/welcome/org',
  '/welcome/org/league-season',
  '/welcome/org/schedule/options',
  '/welcome/org/schedule/preview',
  '/welcome/org/schedule/slots',
  '/welcome/org/teams',
  '/welcome/persona',
  '/welcome/team',
  '/welcome/team/create',
];

export function isWelcomeSetupPathname(pathname: string) {
  const normalizedPathname =
    pathname.length > 1 && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;

  return WELCOME_SKIPPABLE_SETUP_ROUTES.includes(normalizedPathname);
}
